import client from '../../client';
import type { IPutActivateMgptParams, IGetAiAgentModelListParams, IGetAiAgentModelSettingsHistoryParams } from './types';

export const aiAgentModelApis = {
  postFileDownload: (fileUploadId: number) => client.post(`/ai-agent/model/file-download/${fileUploadId}`),
  putActivateMgpt: (data: IPutActivateMgptParams) =>
    client.put(`/equipmentModel/companies/${data.companyId}/models/mgpt-use`, data.data),
  getAiAgentModelList: ({ companyId, ...rest }: IGetAiAgentModelListParams) =>
    client.get(`/ai-agent/companies/${companyId}/models`, {
      params: rest,
    }),
  getAiAgentModelSettingsHistory: (data: IGetAiAgentModelSettingsHistoryParams) =>
    client.get(`/ai-agent/companies/${data.companyId}/models/${data.modelId}/settings/history`, {
      params: {
        page: data.page,
        size: data.size,
        startDate: data.startDate,
        endDate: data.endDate,
        changeType: data.changeType,
        useYn: data.useYn,
        manager: data.manager,
      },
    }),
};
